var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMapNv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;opacity:0;}.b{fill:#002445;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(-8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.25,28.169a12.782,12.782,0,0,1-5.642-1.192C.926,26.127,0,24.937,0,23.626a3.467,3.467,0,0,1,1.648-2.768,9.556,9.556,0,0,1,3.728-1.5l.291,1.471C3.214,21.317,1.5,22.466,1.5,23.626c0,1.439,2.772,3.043,6.75,3.043S15,25.066,15,23.626c0-1.16-1.713-2.309-4.166-2.795l.291-1.471a9.554,9.554,0,0,1,3.727,1.5A3.468,3.468,0,0,1,16.5,23.626c0,1.31-.926,2.5-2.608,3.351A12.782,12.782,0,0,1,8.25,28.169Z",
    transform: "translate(-4.75 -4.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6,18.957a.75.75,0,0,1-.552-.242,32.887,32.887,0,0,1-2.8-3.621c-2.254-3.361-3.4-6.361-3.4-8.92A6.845,6.845,0,0,1,5.994-.749h.013a6.846,6.846,0,0,1,6.744,6.925c0,2.557-1.145,5.558-3.4,8.918a32.955,32.955,0,0,1-2.8,3.621A.75.75,0,0,1,6,18.957ZM6,.751A5.343,5.343,0,0,0,.75,6.166s0,0,0,.006c0,2.81,1.709,5.948,3.143,8.086A33.773,33.773,0,0,0,6,17.062a33.851,33.851,0,0,0,2.106-2.8c1.434-2.138,3.144-5.277,3.144-8.086,0,0,0,0,0-.006A5.344,5.344,0,0,0,6,.751Z",
    transform: "translate(-2.5 1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.25-.75a3.026,3.026,0,0,1,0,6.052,3.026,3.026,0,0,1,0-6.052Zm0,4.552A1.526,1.526,0,0,0,2.25.75a1.526,1.526,0,0,0,0,3.052Z",
    transform: "translate(1.25 4.944)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapNv);
export default __webpack_public_path__ + "static/media/icon_map_nv.8d67223c4160d6577f36890a61a3c83a.svg";
export { ForwardRef as ReactComponent };